import { Form, Button, Col, Row, Card, InputGroup, Tooltip, OverlayTrigger, Table, Modal } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import Amount from '../../core/Amount';
import React, { useEffect, useState } from 'react';
import InfoTooltip from '../../core/ToolTip';
import axios from "axios";
import { Link, useSearchParams, useParams } from "react-router-dom";
import { SpinnerModal, blockInvalidAmount } from '../Util';
import { useNavigate } from 'react-router-dom';

export default function FiscalExpenditureResponse() {
    const navigate = useNavigate();
    const FISCAL_BASE_URL = process.env.REACT_APP_FISCAL_BASE_URL;
    const FISCAL_POST = process.env.REACT_APP_FISCAL_POST;
    const FISCAL_PUT = process.env.REACT_APP_FISCAL_PUT;
    const FISCAL_GET_ID = process.env.REACT_APP_FISCAL_GET_ID;

    const data = {
        splEventAmount: "",
        membershipAmount: "",
        fundraising: "",
        grantsmanship: "",
        empSalaries: "",
        adminExpenses: "",
        siteImprovements: "",
        capitalExpenditures: "",
        collectionAcquisitions: "",
        utilities: "",
        waterSewegeSeptic: "",
        trashRemoval: "",
        groundsCare: "",
        pestControl: "",
        maintenanceSupplies: "",
        plumbingElectrical: "",
        houseKeeping: "",
        insurance: "",
        marketing: "",
        museumStore: "",
        consultantFees: "",
        depreciation: "",
        website: "",
        other: "",
        totalExpenditures: ""

    }

    const [formData, setFormData] = useState(data);
    const [fiscalFormData, setFiscalFormData] = useState();

    const handleInputChange = (e) => {
        console.log(e.target.value)
        const { name, value } = e.target;
        const [group, ...keys] = name.split('.');

        if (keys.length > 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];
            keys.forEach((key, index) => {
                if (index === keys.length - 1) {
                    currentLevel[key] = value;
                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }
            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });
        }


    };

    const [spinnerShow, setSpinnerShow] = useState(false);
    const { id } = useParams();
    // const [paramsId, setParamsId] = useState();
    // setParamsId(id);
    console.log("initial id" + id);
    // const { recordId } = useParams();
    useEffect(() => {
        fetchData(id);
    }, [id]);

    const fetchData = (id) => {
        console.log("initial id" + id);
        console.log(id);
        if (id) {
            setSpinnerShow(true);
            const url = FISCAL_BASE_URL + id + FISCAL_GET_ID;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    console.log('response:' + data.siteName);
                    setFiscalFormData(data);
                    setFormData(data.expenditures);
                    setSpinnerShow(false);

                })
        }
    }


    const handleNext = () => {
        navigate(`/museumResponse/${fiscalFormData._id}`);
    }




    return (
        <>

            Fiscal - Expenditure
            <div className="main-content">
                <Form className="main-content" onSubmit={handleNext}>
                    {/* Expenditures Entry */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Expenditures</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="splEventAmount">
                                            <Form.Label>Special Events/Public Programs</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="splEventAmount" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.splEventAmount} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="membership">
                                            <Form.Label>Membership</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="membership" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.membership} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="fundraising">
                                            <Form.Label>Fundraising</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="fundraising" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.fundraising} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="grantsmanship">
                                            <Form.Label>Grantsmanship</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="grantsmanship" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.grantsmanship} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Row>

                                    <Row className="main-content">

                                        <Form.Group as={Col} controlId="empSalaries">
                                            <Form.Label>Employee Salaries and Benefits</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="empSalaries" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.empSalaries} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Employee Salaries and Benefits.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="adminExpenses">
                                            <Form.Label>Administrative Expenses</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="adminExpenses" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.adminExpenses} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="siteImprovements">
                                            <Form.Label>Site Improvements</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="siteImprovements" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.siteImprovements} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="capitalExpenditures">
                                            <Form.Label>Capital Expenditures(Please explain below)</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="capitalExpenditures" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.capitalExpenditures} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="main-content">
                                        <Form.Group as={Col} controlId="collectionAcquisitions">
                                            <Form.Label>Collection Acquisitions/Conservation</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="collectionAcquisitions" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.collectionAcquisitions} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Employee Salaries and Benefits.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="utilities">
                                            <Form.Label>Utilities (electricity, gas, fuel oil, telephone, internet)</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="utilities" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.utilities} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="waterSewegeSeptic">
                                            <Form.Label>Water / Sewage / Septic</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="waterSewegeSeptic" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.waterSewegeSeptic} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="trashRemoval">
                                            <Form.Label>Trash Removal</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="trashRemoval" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.trashRemoval} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Row>
                                    <Row className="main-content">
                                        <Form.Group as={Col} controlId="groundsCare">
                                            <Form.Label>Grounds care (mowing, trimming)</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="groundsCare" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.groundsCare} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="pestControl">
                                            <Form.Label>Pest Control</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="pestControl" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.pestControl} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="maintenanceSupplies">
                                            <Form.Label>Maintenance supplies and equipment</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="maintenanceSupplies" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.maintenanceSupplies} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="plumbingElectrical">
                                            <Form.Label>Plumbing/Electrical/ Contracted Services</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="plumbingElectrical" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.plumbingElectrical} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Row>
                                    <Row className="main-content">
                                        <Form.Group as={Col} controlId="houseKeeping">
                                            <Form.Label>Housekeeping (janitorial, carpet cleaning, window washing)</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="houseKeeping" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.houseKeeping} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="insurance">
                                            <Form.Label>Insurance (Liability, D&O, Workers Comp)</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="insurance" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.insurance} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="marketing">
                                            <Form.Label>Marketing</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="marketing" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.marketing} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="museumStore">
                                            <Form.Label>Museum Store</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="museumStore" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.museumStore} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="main-content">


                                        <Form.Group as={Col} controlId="consultantFees">
                                            <Form.Label>Consultant / Professional Fees</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="consultantFees" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.consultantFees} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="depreciation">
                                            <Form.Label>Depreciation</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="depreciation" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.depreciation} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="website">
                                            <Form.Label>Website</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="website" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.website} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="other">
                                            <Form.Label>Other</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="other" disabled
                                                    onKeyDown={blockInvalidAmount} value={formData.other} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the .
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="mb-3 main-content">

                        <Col>
                            <Row className="mb-3 submit">
                                <Col>

                                    <Button variant="primary" name="submit" type="submit" >
                                        Next
                                    </Button>

                                </Col>
                            </Row>
                        </Col>


                        <Col />
                        <Col />
                        <Col />
                    </Row>
                </Form>
            </div>
        </>
    );
}